module.exports = __webpack_public_path__ + "static/media/Tennis-Store01.9c1f8e1a.png";